import { FieldValues, FormState, UseFormReset } from 'react-hook-form';
import { Price, updateProductsPricing } from 'src/api/updateProductsPricing/updateProductsPricing';
import { DELIMITER } from './constants';
import { IItemIdWithPrices } from './types';
import { SnackbarStatus } from '@weareopenr/component-library';
import { SnackbarContextValue } from '@weareopenr/component-library/build/components/Snackbar/types';

export const submitPrices =
  <TFieldValues extends FieldValues>(
    dirtyFields: FormState<TFieldValues>['dirtyFields'],
    products: IItemIdWithPrices[],
    resetForm: UseFormReset<TFieldValues>,
    showSnackbar: SnackbarContextValue['showSnackbar'],
    invalidateQueries: () => Promise<void>,
    priceSchemeId: string,
  ) =>
  async (data: TFieldValues) => {
    const requestBody: Price[] = [];
    const updatedKeys = Object.keys(dirtyFields);

    updatedKeys.forEach((key) => {
      const [itemId, externalSystemId, priceBandId] = key.split(DELIMITER);
      const newPrice = data[key];
      const product = products.find((product) => product.item_id === itemId);
      const existingPrice = product?.prices.find(
        (price) => String(price.price_band_id) === priceBandId && String(price.external_system_id) === externalSystemId,
      );

      if (existingPrice) {
        requestBody.push({
          price_id: existingPrice.price_id,
          item_id: itemId,
          external_system_id: null,
          price_band_id: null,
          value_with_tax: newPrice === '' ? null : parseFloat(newPrice),
        });
      } else {
        requestBody.push({
          price_id: null,
          item_id: itemId,
          external_system_id: externalSystemId === 'null' ? null : externalSystemId,
          price_band_id: priceBandId === 'null' ? null : priceBandId,
          value_with_tax: parseFloat(newPrice),
        });
      }
    });

    try {
      await updateProductsPricing(priceSchemeId, requestBody);

      resetForm(data, { keepValues: true });
      showSnackbar({ status: SnackbarStatus.SUCCESS, message: 'Changes have been successfully saved' });
      invalidateQueries();
    } catch (error) {
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong updating pricing' });
    }
  };
